import Marquee from "react-fast-marquee";
import { BRAND_PARTNERS } from "../data/content";

const BrandPartners = () => (
    <section data-testid="brand-partners-section" className="relative py-14 border-y border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-8">
                <div className="text-xs font-bold uppercase tracking-[0.25em] text-slate-500 dark:text-slate-400">Brand Partners</div>
                <h2 className="mt-2 font-heading text-xl sm:text-2xl font-semibold text-slate-900 dark:text-white">Authorized supplier of leading medical brands</h2>
            </div>
            <Marquee gradient gradientColor="rgb(255,255,255)" speed={50} className="dark:[--gradient-color:15_23_42]">
                {BRAND_PARTNERS.map((b, i) => (
                    <div key={i} data-testid={`brand-${i}`} className="mx-8 sm:mx-12 font-heading font-bold text-2xl sm:text-3xl text-slate-400 dark:text-slate-500 hover:text-brand-700 dark:hover:text-brand-300 transition-colors whitespace-nowrap">
                        {b}
                    </div>
                ))}
            </Marquee>
        </div>
    </section>
);

export default BrandPartners;
